export type DomainFocusItem = {
  focus: string;
  treatment_name: string;
};

export type DomainTree = Record<string, DomainFocusItem[]>;

const isDomainFocusItem = (value: unknown): value is DomainFocusItem => {
  if (!value || typeof value !== "object") return false;
  const item = value as Record<string, unknown>;
  return typeof item.focus === "string";
};

export const normalizeDomainTree = (raw: unknown): DomainTree => {
  if (!raw || typeof raw !== "object") return {};

  const tree: DomainTree = {};

  Object.entries(raw as Record<string, unknown>).forEach(([domain, focuses]) => {
    if (!Array.isArray(focuses)) {
      tree[domain] = [];
      return;
    }

    tree[domain] = focuses
      .map((item): DomainFocusItem | null => {
        if (typeof item === "string") {
          return { focus: item, treatment_name: item };
        }
        if (isDomainFocusItem(item)) {
          const treatmentName =
            typeof item.treatment_name === "string" && item.treatment_name.trim()
              ? item.treatment_name
              : item.focus;
          return { focus: item.focus, treatment_name: treatmentName };
        }
        return null;
      })
      .filter((item): item is DomainFocusItem => item !== null);
  });

  return tree;
};

export const getFocusDisplayName = (
  focus: string,
  domainTree: DomainTree,
  domain?: string | null
): string => {
  if (!focus) return focus;

  if (domain && domainTree[domain]) {
    const match = domainTree[domain].find((item) => item.focus === focus);
    if (match) return match.treatment_name || match.focus;
  }

  for (const items of Object.values(domainTree)) {
    const match = items.find((item) => item.focus === focus);
    if (match) return match.treatment_name || match.focus;
  }

  return focus;
};
